export default {
  styleOverrides: {
    root: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
};
